var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Chart as ChartJS, ArcElement, Title, Tooltip } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { useTheme } from 'styled-components';
import { assetColor } from '../../themes/assetColor';
// https://react-chartjs-2.js.org/docs/migration-to-v4#tree-shaking
ChartJS.register(Title, Tooltip, ArcElement);
export var AllocationDoughnut = function (_a) {
  var _b;
  var assets = _a.assets,
    _c = _a.options,
    options = _c === void 0 ? {} : _c;
  var theme = useTheme();
  return _jsx(Doughnut, {
    data: {
      datasets: [{
        backgroundColor: assets.map(function (_a) {
          var id = _a.id;
          return assetColor(theme, id);
        }),
        borderWidth: 0,
        data: assets.map(function (_a) {
          var weight = _a.weight;
          return weight * 100;
        })
      }],
      labels: []
    },
    options: __assign(__assign({
      cutout: '75%',
      maintainAspectRatio: false,
      responsive: true
    }, options), {
      hover: __assign({
        mode: undefined
      }, options.hover || {}),
      plugins: {
        tooltip: __assign({
          enabled: false
        }, ((_b = options.plugins) === null || _b === void 0 ? void 0 : _b.tooltip) || {})
      }
    })
  });
};